<script setup lang="ts">
import { FloatingBox, globalOverlayContainer, SlideTransition } from '#shared'
import { computed } from 'vue'

const {
  date,
  targetEl,
  isShown,
  verticalPosition = 'top-outside',
  horizontalPostion = 'center',
} = defineProps<{
  date: Date | string
  targetEl: HTMLElement | null
  isShown: boolean
  verticalPosition?: 'bottom-outside' | 'top-outside' | 'center'
  horizontalPostion?: 'left-outside' | 'left-inside' | 'right-outside' | 'right-inside' | 'center'
}>()

const normalizedDate = computed(() => new Date(date))

const boxOffsetY = computed(() => {
  if (verticalPosition === 'top-outside') return -5
  if (verticalPosition === 'bottom-outside') return 5
  return 0
})
const transitionOffsetY = computed(() => boxOffsetY.value * 2)

const boxOffsetX = computed(() => {
  if (horizontalPostion === 'left-outside') return -5
  if (horizontalPostion === 'right-outside') return 5
  return 0
})
const transitionOffsetX = computed(() => boxOffsetX.value * 2)
</script>

<template>
  <Teleport :to="globalOverlayContainer">
    <SlideTransition :offsetY="transitionOffsetY" :offsetX="transitionOffsetX">
      <FloatingBox
        v-if="isShown"
        :horizontalPosition="horizontalPostion"
        :verticalOffset="boxOffsetY"
        :horizontalOffset="boxOffsetX"
        :verticalPosition="verticalPosition"
        :targetEl="targetEl"
      >
        <div :class="$style.root">
          {{ normalizedDate.toLocaleString('en-US') }}
        </div>
      </FloatingBox>
    </SlideTransition>
  </Teleport>
</template>

<style lang="scss" module>
.root {
  background-color: #1f1f22;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  border: 1px solid #404045;
  white-space: nowrap;
  width: fit-content;
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
}
</style>
